<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="goBack()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>Geavanceerd</v-toolbar-title>
			<v-btn icon></v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<v-list two-line class="py-0" v-if="device">

				<v-container class="item-group" mb-2>
					<div class="headline">
						{{ device.name }}
					</div>
					<div>
						ID: {{ device.id_for_humans }}
					</div>
					<div>
						EID: {{ device.eid }}
					</div>
					<div>
						Firmware: {{ device.getFirmware() }}
					</div>
				</v-container>

				<v-list-tile class="pt-0" v-if="device.latest_state">
					<v-select
						:append-icon="device.target_profile == device.latest_state.profile_id ? 'done' : 'hourglass_empty'"
						:value="device.target_profile"
						:items="[{text: 'Standaard', value: '1'}, {text: 'Extra gevoelig', value: '0'}]"
						label="Gevoeligheid"
						placeholder="Maak een keuze..."
						ref="selectBoxSensitivity"
						@change="setProfile"
					>
					</v-select>
				</v-list-tile>

				<v-container class="item-group" mb-4 v-if="!isRunningInBrowser">
					<v-list-tile-content>
						<v-list-tile-title class="mb-2">Bluetooth</v-list-tile-title>
						<p>Zorg dat je E-finder is aangesloten op het netstroom om verbinding te maken.</p>
						<v-btn block depressed dark large color="primary" @click="gotoBle()">
							<v-icon>bluetooth</v-icon>Verbinden
						</v-btn>
					</v-list-tile-content>
				</v-container>

			</v-list>
		</v-content>
	</div>
</template>

<script>
  export default {
    computed: {
      device() {
        return this.$store.getters.device;
      },
    },
    data() {
      return {
        dialogError: null,
	  	query: '',
        isRunningInBrowser: process.env.CORDOVA_PLATFORM === 'browser'
	  };
    },
    methods: {
      goBack() {
        this.$router.go(-1);
	  },
      showMenu() {
        this.$store.dispatch('openMainMenu');
      },
      gotoMap() {
        return this.$router.push({ name: 'devices.index' });
      },
	  gotoBle(){
        return this.$router.push({name: 'devices.ble', props: {id: this.device.id_for_humans}});
	  },
      gotoDevice(device) {
        if (device.isWaitingForActivation()) {
          return this.$router.push({ name: 'devices.activate', params: { id: device.id } });
        }
        if (!device.getState()) return;
        this.$router.push({ name: 'devices.show', params: { id: device.id } });
      },
      setProfile(value) {
        this.$store.dispatch('updateDevice', {
          id: this.device.id,
          data: { target_profile: value },
        })
          .catch((e) => {
            this.dialogError = 'Gevoelighied kan niet ingeschakeld worden.';
          });
      },
    },
    created() {
      this.$store.dispatch('selectDevice', this.$route.params.id);
    }
  };
</script>
